import {useCallback} from "react";
import {useDispatch, useSelector} from "react-redux";
import apiClient from "../../utils/apiClient";
import {setCashSession} from "../../core/redux/action";

const EMPTY_STATE = { session: null, metrics: null };

const useCashSession = () => {
  const dispatch = useDispatch();
  const cashSession = useSelector((state) => state.rootReducer.cashSession);
  const current_location = useSelector((state) => state.rootReducer.current_location);
  const locationId = current_location?._id;

  const refreshCashSession = useCallback(async () => {
    if (!locationId) {
      dispatch(setCashSession(EMPTY_STATE));
      return EMPTY_STATE;
    }

    try {
      const res = await apiClient.get(`/locations/${locationId}/cash-sessions/active`);
      const payload = res.data || EMPTY_STATE;
      dispatch(setCashSession(payload));
      return payload;
    } catch (error) {
      dispatch(setCashSession(EMPTY_STATE));
      return EMPTY_STATE;
    }
  }, [dispatch, locationId]);

  return { cashSession, refreshCashSession, current_location };
};

export default useCashSession;
